import {
  BiContextProvidedValue,
  BiData,
  type ThumbClickUnfaveBiEvent,
  type ThumbFaveBiEvent,
} from '@wix/da-bi/pkg/events';
import type { PapiDeviation } from '@wix/da-papi-types';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeFaveCustom } from '../CollectionPanel/redux/actionCreators';
import {
  getFaveCount,
  getIsFaveLoading,
  getIsFavourite,
} from '../CollectionPanel/redux/selectors';
import { getDeviationResourceType } from '../DeviationViews/_helpers';
import { CollectionStoreState } from '../CollectionPanel';

export function useFaveButton(
  deviation: PapiDeviation,
  notificationQueue = 'default'
) {
  const isFavourite = useSelector((state: CollectionStoreState) =>
    getIsFavourite(state, deviation)
  );
  const isLoading = useSelector((state: CollectionStoreState) =>
    getIsFaveLoading(state, deviation)
  );
  const faveCount = useSelector((state: CollectionStoreState) =>
    getFaveCount(state, deviation)
  );
  const dispatch = useDispatch();

  const biData = BiData<ThumbClickUnfaveBiEvent | ThumbFaveBiEvent>({
    evid: isFavourite ? 109 : 102,
    typeid: getDeviationResourceType(deviation),
    creatorid: deviation.author?.useridUuid ?? '',
    itemid: deviation.deviationId,
    sectionname: BiContextProvidedValue,
    sectionid: BiContextProvidedValue,
    section_typeid: BiContextProvidedValue,
    sectiontype: BiContextProvidedValue,
    sectionrank: BiContextProvidedValue,
    rank: BiContextProvidedValue,
    sort_type: BiContextProvidedValue,
    reason_shown: BiContextProvidedValue,
    widgetname: BiContextProvidedValue,
  });

  const onClick = useCallback(
    () =>
      dispatch(changeFaveCustom(deviation, !isFavourite, notificationQueue)),
    [deviation, dispatch, isFavourite, notificationQueue]
  );

  return { isFavourite, faveCount, isLoading, biData, onClick };
}
